import React from 'react';

const ServiceArea = () => {
  const locations = [
    "Barrie", "Collingwood", "Orillia", "Innisfil", 
    "Wasaga Beach", "Midland", "Penetanguishene", "Stayner"
  ];

  return (
    <section className="py-8 bg-gradient-to-br from-green-50 to-red-50">
      <div className="container mx-auto px-6 text-center">
        <h2 className="dest_heading mb-8">Serving Simcoe County & Beyond</h2>
        <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
          We proudly serve homeowners and businesses throughout Simcoe County with professional 
          Christmas light installation services. Our local expertise ensures your holiday lighting 
          is installed safely and beautifully.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {locations.map((location, index) => (
            <div key={index} className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <span className="text-red-700 font-semibold">{location}</span>
            </div>
          ))}
        </div>
        <p className="text-gray-600 mt-8">
          Don't see your area? Contact us - we may still be able to help!
        </p>
      </div>
    </section>
  );
};

export default ServiceArea;